import { IWalletEventMetadata, IWalletEventTicketCode } from 'meta/pages/v4/wallet'
import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'

type Props = {
  eventIdOrCodeUrl: string
  page: number
}

type Response = { items: Array<IWalletEventTicketCode>; metadata: IWalletEventMetadata }

export const getEventTicketCodes = async (props: Props): Promise<Response> => {
  const { eventIdOrCodeUrl, page } = props

  const endpoint = ApiEndpoint.v4.wallet.eventTicketCodes(eventIdOrCodeUrl, page)

  const { data, metadata } = await HttpRequestForApiV4.get<
    { items: Array<IWalletEventTicketCode> },
    IWalletEventMetadata
  >(endpoint)

  return { items: data.items, metadata }
}
